import { DefaultTheme } from 'styled-components';
export const lightTheme: DefaultTheme = {
  type: 'light',
  // default space for margin and padding
  space: (n: number): number => n * 4,
  fontSize: [12, 14, 16, 20, 24, 28, 32],
  borderRadius: '16px',
  borderInputRadius: '8px',
  boxShadow: '0px 3px 7px rgba(33, 33, 33, 0.1)',
  palette: {
    neutral: {
      neutral100: '#2C2E30', //mk1
      neutral75: '#424547', //mk2
      neutral45: '#B3B9BE',
      neutral30: '#E3E6E8', //contour
      neutral15: '#E3E6E8', //beam
      base: '#F4F4F7', //base
      surface2: '#FAFAFA', //compartment
      surface: '#ffffff',
    },
    primary: {
      primary700: '#371E47', // dark
      primary600: '#4B286D', //main
      primary500: '#615DE9', // light
      primary300: '#7C53A5',
      primary200: '#D8CBE5',
      primary50: '#F2EFF4', //ultraLight
    },
    secondary: {
      red300: '#C12335', //main , light, dark
    },
    tertiary: {
      yellow300: '#FFE36E', //main , light, dark
    },
    quaternary: {
      blue300: '#7C53A5', //main , light, dark
    },
    system: {
      verified: {
        main: '#2B8000', // dark
        light: '#EAF2E5',
      },
      alert: {
        main: '#C12335', // dark
        red50: '#F9E9EB', // ultraLight
      },
      query: {
        main: '#2C2E30', // dark
        yellow50: '#FFFCF0',
      },
      info: {
        main: '#4B286D',
        blue50: '#EDE9F0',
        focus: '#2681E1',
      },
    },
  },
};
